import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: hub page for the deleted bank x loan-type matrix.
// Money/EMI calculators that are genuinely useful remain reachable
// from /calculators and /tools.
export const Route = createFileRoute("/loan-hub")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
